
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import configureMarkerIO from './utils/configureMarkerIO';
import { getEnvironmentName } from './lib/environment';

// Initialize Marker.io for bug reporting
configureMarkerIO({
  version: getEnvironmentName(),
});

createRoot(document.getElementById("root")!).render(<App />);
